import {defineStore} from "pinia";
import {useLayoutSections} from "@/store/plugins/useLayoutSections";
import {CatalogStore, LayoutSections} from "@/types/catalog-store";

let layoutSections: LayoutSections = {};

export function loadLayoutSections(): void {
    const loadLayoutSection = (slotId: string): string | undefined => {
        const node = document.querySelector<HTMLElement>('[data-slot-id="' + slotId + '"]');
        if (!node) {
            return undefined;
        }

        removeAttrRecursively(node, "data-initialized");
        const nodeOuterHtml = node.outerHTML ?? undefined;
        node.remove();

        return nodeOuterHtml;
    };

    layoutSections = {
        categoryNav: loadLayoutSection("category-nav"),
        banner: loadLayoutSection("banner"),
        categoryHeader: loadLayoutSection("category-header"),
        subCategories: loadLayoutSection("sub-categories"),
        topSeller: loadLayoutSection("top-seller"),
        recommendedList: loadLayoutSection("recommended-list"),
    };
}

function removeAttrRecursively(node: Element, attributeName: string): void {
    node.removeAttribute(attributeName);
    for (const child of node.children) {
        removeAttrRecursively(child, attributeName);
    }
}

export const useCatalogStore = defineStore("CatalogStore", () => {
    const layoutSectionsPlugin = useLayoutSections(layoutSections);

    return {
        ...layoutSectionsPlugin,
    }
});

export type CatalogStoreType = ReturnType<typeof useCatalogStore>;
declare const typeCheckStore: CatalogStoreType;

function typeCheckStoreNoop(): void {
    // noinspection BadExpressionStatementJS
    typeCheckStore satisfies CatalogStore;
}
